export const NETWORK_PERFORMANCE_SET_DATE_RANGE =
  'NETWORK_PERFORMANCE/SET_DATE_RANGE';
export const NETWORK_PERFORMANCE_SET_STUDIOS =
  'NETWORK_PERFORMANCE/SET_STUDIOS';
export const NETWORK_PERFORMANCE_SET_GRANULARITY =
  'NETWORK_PERFORMANCE/SET_GRANULARITY';
export const NETWORK_PERFORMANCE_GET_DASHBOARD =
  'NETWORK_PERFORMANCE/GET_DASHBOARD';
export const NETWORK_PERFORMANCE_DOWNLOAD_REPORT =
  'NETWORK_PERFORMANCE/DOWNLOAD_REPORT';
